import React, { useEffect, useState } from "react";
import {
  StyledLandingScreen,
  SearchTriggerButton,
  ReservationReminder,
} from "./styles";
import { Header, BottomNav, FlexDiv } from "../../components/index";
import SearchModal from "../../components/SearchModal";
import PropertyList from "../../components/PropertyList";
import assets from "../../assets/index";
import { useReservations, useProperties } from "../../hooks/";
import { useLocation, useNavigate } from "react-router-dom";
import { Reservation } from "../../types/reservation";

type ReservationsResponse = {
  items: Reservation[];
  pagination: {
    page: number;
    items_per_page: number;
    total_items: number;
  };
};

const SearchModalTrigger = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <SearchTriggerButton onClick={() => setModalOpen(true)}>
        <img src={assets.SearchIcon} alt="search-icon" height={20} />
        <p>Find your perfect getaway</p>
      </SearchTriggerButton>
      {isModalOpen && <SearchModal onClose={() => setModalOpen(false)} />}
    </>
  );
};

const LandingScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [greeting, setGreeting] = useState("");
  const [titleText, setTitleText] = useState("");

  const { reservations } = useReservations();
  const { properties, loading: isPropertiesLoading } = useProperties();

  useEffect(() => {
    const currentHour = new Date().getHours();

    if (location.pathname === "/inbox") {
      setGreeting(""); // No greeting for the inbox page
      setTitleText("Your messages");
    } else {
      if (currentHour >= 6 && currentHour < 12) {
        setGreeting("Rise and shine ☀️,");
        setTitleText("Traveller!");
      } else if (currentHour >= 12 && currentHour < 18) {
        setGreeting("Good afternoon,");
        setTitleText("Adventurer!");
      } else if (currentHour >= 18 && currentHour < 21) {
        setGreeting("Good evening,");
        setTitleText("Dear Guest!");
      } else {
        setGreeting("Good night, traveller!");
        setTitleText("Relax and unwind!");
      }
    }
  }, [location.pathname]);

  const reservationsList =
    (reservations as unknown as ReservationsResponse)?.items || [];

  const allUnits = properties.flatMap((property) => property.units || []);

  const getTomorrowReservations = () => {
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setUTCDate(today.getUTCDate() + 1);

    return reservationsList.some((reservation) => {
      const fromDate = new Date(reservation.fromDate);
      const toDate = new Date(reservation.toDate);

      fromDate.setUTCHours(0, 0, 0, 0);
      toDate.setUTCHours(0, 0, 0, 0);

      return fromDate <= tomorrow && tomorrow <= toDate;
    });
  };

  const hasTomorrowReservation = getTomorrowReservations();

  return (
    <StyledLandingScreen>
      <Header />

      <FlexDiv justifycontent="space-between">
        {" "}
        <div className="greeting">
          <h4>{greeting}</h4>
          <h1>{titleText}</h1>
        </div>
      </FlexDiv>

      {properties.length > 0 ? (
        <SearchModalTrigger />
      ) : (
        <div style={{ height: 40 }}></div>
      )}
      {hasTomorrowReservation && (
        <ReservationReminder onClick={() => navigate("/reservations")}>
          <div className="circle">1</div>
          <p>Upcoming Reservation for Tomorrow</p>
          <img src={assets.ArrowRightIcon} alt="arrow-right" />
        </ReservationReminder>
      )}

      <PropertyList
        properties={allUnits}
        loading={isPropertiesLoading}
        onUnitClick={(uid: string) => navigate(`/unit/${uid}`)}
      />
      {/*<MapButton
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          setShowMapModal(true);
        }}
      >
        <img src={assets.mapIcon} height={16} alt="show map button icon" />
        <span className="map-text">Show Map</span>
      </MapButton>*/}

      {/*showMapModal && (
        <MapModal
          onClose={() => setShowMapModal(false)}
          properties={properties}
        />
      )*/}

      <BottomNav />
    </StyledLandingScreen>
  );
};

export default LandingScreen;
